import _ from 'lodash';
import Immutable from 'immutable';

const EMAIL_REGEX = /^[A-Z0-9._!'%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

/**
 * @param {String} value An email address
 * @returns {boolean} true if it conforms to the format of a valid email address.
 */
function email(value) {
  return matches(value, EMAIL_REGEX);
}

/**
 * @param value
 * @returns {boolean} true if a value was provided
 */
function required(value) {
  if (Immutable.List.isList(value)) {
    return value.count() > 0;
  }
  return !(value === '' || value === null || value === undefined);
}

/**
 *
 * @param value
 * @returns {boolean} true if a non-blank value was provided
 */
function nonEmpty(value) {
  return _.isString(value) && value.trim();
}

/**
 * @param value
 * @param regex
 * @returns {*|boolean} True if the value conforms to the regex.
 */
function matches(value, regex) {
  return _.isString(value) && !!value.match(regex);
}

/**
 * @param value
 * @param [lower]
 * @param [upper]
 * @returns {boolean} true if the value is between the lower and upper values inclusive.
 */
function inRange(value, lower, upper) {
  if (_.isNumber(lower) && value < lower) {
    return false;
  }
  if (_.isNumber(upper) && value > upper) {
    return false;
  }
  return true;
}

/**
 * Validate the length of the value against another validator.
 * @param [value='']
 * @param validator A validator
 * @param args Extra args for the validator
 * @returns {boolean} true if valid
 */
function validateLength(value, validator, ...args) {
  if (!value) {
    value = '';
  }
  return validator(value.length, ...args);
}

/**
 * Validate a trimmed value against another validator
 * @param {string} value
 * @param validator A validator
 * @param args Extra args for the validator
 * @returns {*}
 */
function validateTrimmed(value, validator, ...args) {
  if (!_.isString(value)) {
    return validator(value, ...args);
  }
  return validator(value.trim(), ...args);
}

export {
  email,
  required,
  nonEmpty,
  matches,
  inRange,
  validateLength,
  validateTrimmed,
};
